import React from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'

export const agents = {
  useInvokeAgent: () => {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async ({ message, threadId, attachments }) => {
        const { data } = await postNamedCommand('agents', 'invoke-ddp-designer', {
          message,
          threadId,
          attachments
        })
        return data
      },
      onSuccess: (data) => {
        // Invalidate thread query to trigger refetch
        if (data.threadId) {
          queryClient.invalidateQueries({ queryKey: ['agents/thread', data.threadId] })
        }
      }
    })
  },

  useAgentThread: (threadId, options = {}) => {
    const { enabled = true } = options
    const queryResult = useQuery({
      queryKey: ['agents/thread', threadId],
      enabled: enabled && !!threadId,
      queryFn: async () => {
        const { data } = await postNamedQuery('agents', 'get-agent-thread', {
          threadId,
          detail: 'full'
        })
        return data
      }
    })

    const refetchRef = React.useRef(queryResult.refetch)
    refetchRef.current = queryResult.refetch

    // Set up polling based on status
    React.useEffect(() => {
      if (!queryResult.data || !threadId) return

      const status = queryResult.data?.status
      const shouldPoll = status === 'pending' || status === 'running'

      if (shouldPoll) {
        const interval = setInterval(() => {
          refetchRef.current()
        }, 1500)

        return () => clearInterval(interval)
      }
    }, [queryResult.data, threadId])

    return queryResult
  }
}
